module.exports = __webpack_public_path__ + "static/img/hysteroscope-detail-6.98bb107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-detail-6.jpg
// module id = 7JOX
// module chunks = 51